// import React from 'react'

import Button from '../../button/button'

import { VscLayoutSidebarLeft, VscLayoutSidebarLeftOff, VscLayoutPanel, VscLayoutPanelOff, VscMenu } from 'react-icons/vsc'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { appConfig } from '../../../config'
import { useTranslation } from 'react-i18next'
import { GiSolarSystem  } from "react-icons/gi";

import './topNav.scss'

type TopNavPorps = {
  explorerSize: number,
  setExplorerSize: (explorerSize: number) => void,
  footerSize: number,
  setFooterSize: (footerSize: number) => void
}

function TopNav(props: Readonly<TopNavPorps>) {
  const { t } = useTranslation()
  const [lastExplorerSize, setLastExplorerSize] = useState(props.explorerSize)
  const [lastFooterSize, setLastFooterSize] = useState(props.footerSize)
  const location = useLocation()

  const handleExplorerOpenClose = () => {
    if(props.explorerSize > 0) {
      setLastExplorerSize(props.explorerSize)
      props.setExplorerSize(0)
    } else {
      props.setExplorerSize(lastExplorerSize)
    }
  }

  const handleFooterOpenClose = () => {
    if(props.footerSize > 0) {
      setLastFooterSize(props.footerSize)
      props.setFooterSize(0)
    } else {
      props.setFooterSize(lastFooterSize)
    }
  }

  return (
    <div className='comp-topNav'>
      
      <div className='topNav-main topNav-mainDesk'>
        <GiSolarSystem className='main-icon' />
        <Button title={'File'} click={() => {}} dropdown={[]}/>
        <Button title={'Edit'} click={() => {}} dropdown={[]}/>
        <Button title={'Selection'} click={() => {}} dropdown={[]}/>
        <Button title={'View'} click={() => {}} dropdown={[]} dropdownPosition='bottomLeft'/>
      </div>    
      
      <div className='topNav-main topNav-mainMobile'>
        <GiSolarSystem className='main-icon' />
        <Button 
          icon={<VscMenu />}
          click={() => {}}
          dropdown={[]}
        />
      </div>

      <div className='topNav-mid'>
        <div className='mid-title'>
          {appConfig.map((conf) => {
            const title =  location.pathname === conf.path ? conf.title : '' 
            if(title.length > 0) {
              return t('navLeft.' + title)
            }
            return 'error'
          })}
        </div>
      </div>

      <div className='topNav-second'>
        <Button
          icon={props.explorerSize > 0 ? <VscLayoutSidebarLeft /> : <VscLayoutSidebarLeftOff />}
          click={handleExplorerOpenClose}
        />
        <Button
          icon={props.footerSize > 0 ? <VscLayoutPanel /> : <VscLayoutPanelOff />}
          click={handleFooterOpenClose}
        />
      </div>
    </div>
  )
}

export default TopNav
